export default __webpack_public_path__ + "static/media/profile.87fa19c2.webp";